import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const ReportSectionRoot = superstyled({
  name: 'ReportSection',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(2),
    padding: theme.spacing(3, 0),
    borderBottom: `1px solid ${theme.palette.border.main}`,
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.grey.light
  })
});

export const SectionHeader = superstyled({
  name: 'ReportSection',
  slot: 'Header',
  tag: Box,
  styles: ({ theme, isbubble = false }) => ({
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: isbubble ? '#E1EBFF' : 'transparent',
    borderRadius: theme.shape.borderRadius * (isbubble ? 1 : 0),
    padding: theme.spacing(isbubble ? 3 : 0),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(2),
      padding: theme.spacing(isbubble ? 3 : 0, isbubble ? 3 : 0)
    }
  })
});

export const SectionIcon = superstyled({
  name: 'ReportSection',
  slot: 'Icon',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(3),
    height: theme.spacing(3),
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius * 0.5,
    background: theme.palette.background.green.light,
    color: `#3971E7`
  })
});

export const SectionTitle = superstyled({
  name: 'ReportSection',
  slot: 'Title',
  tag: Text,
  styles: ({ theme }) => ({
    fontWeight: theme.typography.fontWeightMedium,
    color: theme.palette.text.primary
  })
});

export const SectionTitleSection = superstyled({
  name: 'ReportSection',
  slot: 'Title',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(2)
    }
  })
});

export const SectionContent = superstyled({
  name: 'ReportSection',
  slot: 'Content',
  tag: Text,
  styles: ({ theme }) => ({
    lineHeight: 1.6,
    color: theme.palette.text.primary
  })
});
